<template>
  <ModelManagerPage
          lower-app-name="emarket"
          lower-model-name="goods"
          version="2"
          obj-label="商品">
  </ModelManagerPage>
</template>

<script>
import ModelManagerPage from './ModelManagerPage.vue'

export default {
  name: 'GoodsManager',
  props: {
  },
  components: {
    ModelManagerPage
  },
  data: function () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// GoodsManager.vue?fd96a56c